import { isNil } from 'lodash';
import makeDataAccessHoc from './makeDataAccessHoc';
import organisationStructures from './organisationStructures.graphql';
const withOrganisationStructures = makeDataAccessHoc(organisationStructures, {
    options: ({ orgGroupId, status }) => ({
        skip: isNil(orgGroupId),
        variables: {
            status,
            orgGroupId,
        },
    }),
});
export default withOrganisationStructures;
